<template>
  <div class="war-room-deal-story-post-header">
    <BravadoText variant="caption1 semibold" class="war-room-deal-story-post-header__badge">
      <DealStoryBadge />
    </BravadoText>
    <BravadoText
      tag="h1"
      variant="header4"
      class="war-room-deal-story-post-header__title"
      data-test="war-room-deal-story-post-header__title"
    >
      <WarRoomDealStoryHeaderFormatter
        :author="author"
        :company="company"
        :amount="amount"
        :departments="departments"
      />
    </BravadoText>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import BravadoText from '~/components/common/BravadoText/BravadoText.vue';
import DealStoryBadge from '~/components/partials/war-room/WarRoomDeal/DealStoryBadge.vue';
import WarRoomDealStoryHeaderFormatter from '~/components/partials/war-room/WarRoomDeal/WarRoomDealStoryHeaderFormatter.vue';

export default Vue.extend({
  name: 'WarRoomDealStoryPostHeader',
  components: {
    WarRoomDealStoryHeaderFormatter,
    BravadoText,
    DealStoryBadge,
  },
  props: {
    author: {
      type: String,
      required: true,
    },
    company: {
      type: String,
      default: 'a deal',
    },
    amount: {
      type: Number,
      required: true,
    },
    departments: {
      type: Array,
      default: () => [],
    },
  },
});
</script>

<style lang="scss" scoped>
.war-room-deal-story-post-header {
  margin: 20px 0;

  &__badge {
    margin-bottom: 8px;
  }

  &__title {
    color: var(--theme-color-text);
    margin: 0;
  }
}
</style>
